import {AnyAction} from '@reduxjs/toolkit';
import {call, put, select, takeLatest} from 'redux-saga/effects';
import {IResponseStatus} from '../reducers/LeadImplantReducers';
import * as Services from '../services/leadImplantService'
import {parseResponse} from '../../../store/saga/responseParser';
import * as Constants from '../constant/LeadImplantConstants';

function* doCreateLeadImplant(action: AnyAction) {
  console.log(`saga create lead implant start action ${JSON.stringify(action)}`);
  const getApiKey = (state: any) => state.authReducer.token;
  
  try {
    const api_key: string = yield select(getApiKey);

    const response: IResponseStatus = yield call(
      Services.addLeadImplant,
      api_key,
      action.data,
    );

    yield call(
      parseResponse,
      response,
      Constants.ADD_LEAD_IMPLANT_SUCCESS,
      Constants.ADD_LEAD_IMPLANT_FAILED,
    );
    response.status === 201
      ? action.resolve(response.data)
      : action.reject(response.data.error);
  } catch (error) {
    yield put({ type: Constants.ADD_LEAD_IMPLANT_FAILED, error });
  }
}

export const leadImplantSaga = [
    takeLatest(Constants.ADD_LEAD_IMPLANT, doCreateLeadImplant),
]
